export default "__VITE_ASSET__DdVRJNqv__"